import React, { createContext, useState } from 'react';
/**
 * Context values:
 * - completeFeedback: feedback object
 * - setCompleteFeedback: setter for feedback
 * - showFeedback: controls feedback popup visibility
 * - setShowFeedback: setter for feedback popup
 * - showModal: controls thank you modal visibility
 * - setShowModal: setter for thank you modal
 * - showStaticThanks: controls static thanks message visibility
 * - setShowStaticThanks: setter for static thanks message
 */

export const GeneralFeedbackContext = createContext();
export const GeneralFeedbackProvider = ({ children }) => {
  const [completeFeedback, setCompleteFeedback] = useState({
    rating: '',
    feedback: ''
  })
  const [showFeedback, setShowFeedback] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showStaticThanks, setShowStaticThanks] = useState(false);
  

  return (
    <GeneralFeedbackContext.Provider value={{ completeFeedback, setCompleteFeedback, showFeedback, setShowFeedback, showModal, setShowModal, showStaticThanks, setShowStaticThanks }}>
      {children}
    </GeneralFeedbackContext.Provider>
  );
};